import { render } from "./VehiclesModeration.vue?vue&type=template&id=7ee2b5f0&ts=true"
import script from "./VehiclesModeration.vue?vue&type=script&lang=ts"
export * from "./VehiclesModeration.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./VehiclesModeration.vue?vue&type=style&index=0&id=7ee2b5f0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__